"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxField = exports.BaseCheckboxField = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var react_feather_1 = require("react-feather");
var Text_1 = require("./Text");
var theme_1 = require("./theme");
var UIComponents_1 = require("./UIComponents");
var colors_1 = require("./utils/colors");
var CheckboxLabel = function (props) { return (react_1.default.createElement(FlexRow, null,
    react_1.default.createElement(StyledLabel, null,
        react_1.default.createElement(VerticallyCenteredRow, null,
            props.children,
            react_1.default.createElement(Text_1.Text, { variant: "paragraphMedium", ml: props.size === "small" ? "8px" : "12px", opacity: props.disabled ? "0.3" : "1" }, props.label))))); };
var FlexRow = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var StyledLabel = styled_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var VerticallyCenteredRow = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var CheckboxInput = function (_a) {
    var onChange = _a.onChange, props = __rest(_a, ["onChange"]);
    var secondaryThemeColor = (0, colors_1.useSecondaryThemeColor)();
    var handleChange = function (event) {
        event.stopPropagation();
        onChange(event.target.checked);
    };
    return (react_1.default.createElement(RelativeDiv, null,
        react_1.default.createElement(StyledInput, __assign({}, props, { type: "checkbox", checked: props.isSelected, onClick: handleChange })),
        react_1.default.createElement(DummyInput, __assign({}, props), props.isSelected ? (react_1.default.createElement(react_feather_1.Check, { color: secondaryThemeColor, strokeWidth: 3, size: props.size === "small" ? 14 : 18 })) : props.partial ? (react_1.default.createElement(react_feather_1.Minus, { color: secondaryThemeColor, strokeWidth: 3, size: props.size === "small" ? 14 : 18 })) : null)));
};
var RelativeDiv = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var DummyInput = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border-radius: 4px;\n  box-shadow: inset 0px 0px 0px 1px ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 0.1s;\n  width: ", ";\n  height: ", ";\n  background: ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  border-radius: 4px;\n  box-shadow: inset 0px 0px 0px 1px ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 0.1s;\n  width: ", ";\n  height: ", ";\n  background: ", ";\n\n  ", ";\n\n  ", ";\n"])), theme_1.theme.colors.gray400, function (_a) {
    var size = _a.size;
    return (size === "small" ? "18px" : "24px");
}, function (_a) {
    var size = _a.size;
    return (size === "small" ? "18px" : "24px");
}, theme_1.theme.colors.white, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return disabled &&
        "\n            box-shadow: inset 0px 0px 0px 1px ".concat(theme.colors.gray400, ";\n            opacity: 0.3;\n    ");
}, function (_a) {
    var isSelected = _a.isSelected, partial = _a.partial, theme = _a.theme;
    return (isSelected || partial) &&
        "\n            background: ".concat(theme.colors.primary, ";\n            box-shadow: inset 0px 0px 0px 1px ").concat(theme.colors.primary, ";\n    ");
});
var StyledInput = styled_1.default.input(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin: 0;\n  opacity: 0;\n  position: absolute;\n  z-index: 1;\n  cursor: ", ";\n  width: ", ";\n  height: ", ";\n\n  ", ";\n"], ["\n  margin: 0;\n  opacity: 0;\n  position: absolute;\n  z-index: 1;\n  cursor: ", ";\n  width: ", ";\n  height: ", ";\n\n  ", ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? "not-allowed" : "pointer");
}, function (_a) {
    var size = _a.size;
    return (size === "small" ? "18px" : "24px");
}, function (_a) {
    var size = _a.size;
    return (size === "small" ? "18px" : "24px");
}, function (_a) {
    var disabled = _a.disabled;
    return !disabled &&
        "\n            &:focus-visible {\n                & ~ ".concat(DummyInput, " {\n                    box-shadow: inset 0px 0px 0px 2px ").concat(theme_1.theme.colors.gray900, ";\n                }\n            }\n    ");
});
var BaseCheckboxField = function (_a) {
    var onChange = _a.onChange, className = _a.className, props = __rest(_a, ["onChange", "className"]);
    return (react_1.default.createElement(UIComponents_1.ui.Wrapper, __assign({ className: className }, props),
        react_1.default.createElement(CheckboxLabel, __assign({}, props),
            react_1.default.createElement(CheckboxInput, __assign({ onChange: onChange }, props)))));
};
exports.BaseCheckboxField = BaseCheckboxField;
var CheckboxField = function (props) {
    var _a = (0, formik_1.useField)(props.name), field = _a[0], helpers = _a[2];
    return (react_1.default.createElement(exports.BaseCheckboxField, __assign({}, props, { isSelected: field.value, onChange: helpers.setValue })));
};
exports.CheckboxField = CheckboxField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
